<template>
  <transition name="x-el-fade-in-linear">
    <div class="silk-popup" v-show="show">
      <div class="popup-mask" :style="popupStyle" @click.self="popupClose">
        <div class="popup-content">
          <i class="el-icon-circle-close" @click="popupClose"/>
          <slot/>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SilkPopup',
  props: ["show"],
  data() {
    return {
      popupStyle: {
        display: "flex",
        "z-index": "1009",
        width: "100%",
        height: "100%",
        position: "fixed",
        "background-color": "rgba(0,0,0,.7)",
        top: 0,
        left: 0,
        "justify-content": "center",
        "align-items": "center"
      },
      bodyScrollTop: 0
    };
  },
  methods: {
    popupClose: function popupClose() {
      this.$emit("popup-close");
    },
  },
  watch: {
    show(val) {
      document.querySelector('body').classList.remove('fixed-header-open')
      if (val) {
        document.querySelector("body").classList.add('silk-modal-open')
        this.bodyScrollTop = window.scrollY;
        document.querySelector("body").style.position = 'fixed';
        document.querySelector("body").style.top = -this.bodyScrollTop + 'px';
      } else {
        document.querySelector("body").classList.remove('silk-modal-open')
        document.querySelector("body").style.position = '';
        document.querySelector("body").style.top = '';
        window.scrollTo(0, this.bodyScrollTop);
      }
      if (this.bodyScrollTop > 114 && val) {
        document.querySelector('body').classList.add('fixed-header-open')
      }
    }
  }
}
</script>
